import { VenueUserRateInput } from '../../graphql/API';
import { venueRateUser } from '../../graphql/mutations';
import { executeGql } from '../../utils/gql-utils';

export const venueRateUserApi = async (input: VenueUserRateInput): Promise<void> => {
  await executeGql(venueRateUser, {
    input,
  });
};
